import { cn } from 'utils/utils';

const NavigationLink = ({
  children,
  href,
  className,
}: {
  children: React.ReactNode;
  href: string;
  className?: string;
}) => {
  return (
    <a
      href={href}
      className={cn('text-white hover:text-brand-brown font-[MuseoSans900] uppercase tracking-[1.5px]', className)}
    >
      {children}
    </a>
  );
};

export default NavigationLink;
